import useIsMobile from '@/helpers/commonHooks/useIsMobile'
import { observer } from 'mobx-react'
import LoginPagePc from './components/LoginPagePc/LoginPagePc'
import LoginPageMobile from './components/LoginPageMobile/LoginPageMobile'

function LoginPage() {
  const isMobile = useIsMobile()

  return isMobile ? <LoginPageMobile /> : <LoginPagePc />
}



export default observer(LoginPage)
